import { Inject, Injectable } from '@angular/core';
import { BantaServiceChatBackend } from '@banta/client';
import { UserAccount } from '@banta/common';
import { FirebaseChatBackend, FirebaseNotificationsProvider } from '@banta/firebase';
import { BantaService, ChatBackendService } from '@banta/sdk';
import { UserService } from '@tytapp/user';

@Injectable()
export class TYTBantaAuthentication {
    constructor(
        private banta : BantaService,
        private firebaseBackend : FirebaseChatBackend,
        @Inject(ChatBackendService)
        private backend : BantaServiceChatBackend,
        private firebaseNotifs : FirebaseNotificationsProvider,
        private userService : UserService
    ) {
        console.log(`[TYT/Banta]: Connecting TYT and Banta auth systems...`);

        if (typeof window === 'undefined')
            return;
        
        this.userService.userChanged.subscribe(user => {
            console.log(`[TYT/Banta]: Notifying Banta of new TYT user`);
            let bantaUser : UserAccount = user ? {
                email: user.email,
                createdAt: new Date(user.created_at).getTime(),
                updatedAt: new Date(user.created_at).getTime(),
                displayName: user.display_name,
                username: user.username,
                avatarUrl: user.profile ? user.profile.avatar : undefined,
                id: user.uuid,
                uid: user.uuid,
                token: this.userService.token,
                permissions: {
                    canChat: (source) => user.entitled,
                    canComment: (source) => user.entitled
                }
            } : null;

            // Tell the Banta UI what user is logged in, so the UI can reflect that
            this.banta.user = bantaUser;

            if (bantaUser) {
                console.log(`[TYT/Banta] Banta is logged in`);
            } else {
                console.log(`[TYT/Banta] Banta is logged out`);
            }

            // Tell the Banta client what user token to use
            this.backend.userToken = this.userService.token;

            // Tell the Firebase-based notifications provider what user is logged in
            // so it can subscribe to the appropriate Firestore notifications collection
            this.firebaseNotifs.user = bantaUser;
        })
    }
}